import styled from 'styled-components';
import Box from '@material-ui/core/Box';

const ToggleContainer = styled(Box)``;
const Styled = {
  ToggleContainer
};

export default Styled;
